import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';

import { DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsButton } from '@frontend/ui/button';
import { DsCard } from '@frontend/ui/card';
import { ContentLink, DeviceService } from '@frontend/vanilla/core';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { GrayoutStyleDirective } from '../../../../common/directives/grayout-style.directive';
import { OpenLinkDirective } from '../../../../common/directives/open-link-directive';
import { OnClickWTDirective } from '../../../../common/web-tracking/onclick-web-tracking.directive';
import { WebAnalyticModel } from '../../../../common/web-tracking/web-analytic.model';
import { CommonEventService } from '../events/common-event.service';
import { PreRequisiteProgress } from '../models/pre-requisite/pre-requisite-progress';
import { optInContent } from '../store/target-promotion.selectors';

interface PreRequisiteViewModel {
    isDeposit: boolean;
    preRequisite: PreRequisiteProgress;
    playNow: ContentLink;
    webAnalyticModel: WebAnalyticModel;
}

@Component({
    selector: 'pre-requisite',
    templateUrl: './pre-requisite.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, NgClass, GrayoutStyleDirective, OpenLinkDirective, OnClickWTDirective, TrustAsHtmlPipe, DsCard, DsButton],
})
export class PreRequisiteComponent implements OnInit, OnChanges {
    @Input() isDeposit: boolean;
    @Input() preRequisite: PreRequisiteProgress;

    isMobile: boolean;
    dsComponents: DSComponents;

    vm$: Observable<PreRequisiteViewModel>;

    constructor(
        private store: Store,
        private commonEventService: CommonEventService,
        private deviceService: DeviceService,
        private designSystemHelperService: DesignSystemHelperService,
    ) {}

    ngOnInit() {
        this.isMobile = this.deviceService.isMobile;
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
    }

    ngOnChanges(): void {
        this.vm$ = combineLatest([this.store.select(optInContent), this.commonEventService.getWAModel()]).pipe(
            map(([optInContent, webAnalyticModel]) => {
                return {
                    preRequisite: this.preRequisite,
                    isDeposit: this.isDeposit,
                    playNow: optInContent?.playNow,
                    webAnalyticModel,
                };
            }),
        );
    }
}
